import { ICustomProperties } from "@microsoft/applicationinsights-core-js";
import {
  ApplicationInsights,
  SeverityLevel,
} from "@microsoft/applicationinsights-web";
import Transport from "winston-transport";

interface ApplicationInsightTransportOptions
  extends Transport.TransportStreamOptions {
  key?: string;
  silent?: boolean;
  level?: Level;
  handleExceptions?: boolean;
  appInsights?: ApplicationInsights;
}

enum LogLevel {
  error,
  warning,
  info,
  debug,
}
export type Level = keyof typeof LogLevel;

const winstonLogLevelMapping: { [level in Level]: SeverityLevel } = {
  error: SeverityLevel.Error,
  warning: SeverityLevel.Warning,
  info: SeverityLevel.Information,
  debug: SeverityLevel.Verbose,
};

export class ApplicationInsightsTransport extends Transport {
  private _client: ApplicationInsights;

  constructor(options: ApplicationInsightTransportOptions = {}) {
    super(options);

    if (options.appInsights) {
      this._client = options.appInsights;
    } else {
      this._client = new ApplicationInsights({
        config: { instrumentationKey: options.key },
      });

      this._client.loadAppInsights();
    }
  }

  log(
    info: {
      level: Level;
      message: string;
      meta?: ICustomProperties;
    },
    callback: () => void
  ): void {
    setImmediate(() => {
      this.emit("logged", info);
    });

    this._client.trackTrace({
      message: info.message,
      severityLevel: winstonLogLevelMapping[info.level],
      properties: info.meta,
    });
    // Envoie des informations vers Application Insights
    this._client.flush();

    callback();
  }

  close(): void {
    this._client.flush();
  }
}
